<section>
  <pdf-viewer [src]="pdfSrc" [original-size]="false"></pdf-viewer>
  <div class="centerBlock center w-100 m-t-0">
    <app-primary-button class="w-100" [block]="true" (click)="$modal.close()">Ok</app-primary-button>
  </div>
</section>
